<template>
    <div>
      <!-- modal -->
      <b-modal
        id="trademarkHistoryFormModal" centered size="lg" no-close-on-backdrop ref="trademarkHistoryFormModal" :title=" $t('trademarkHistory.info')" :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
              <b-col class="col-md-12">
                <b-form-group>
                    <label for="trademark-history-date">{{ $t('trademarkHistory.date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="date"></CustomDatePicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-md-12">
                  <label for="trademark-history-status">{{ $t('trademarkHistory.status') }}</label>
                  <b-form>
                    <validation-provider :name="$t('trademarkHistory.status')" :rules="{ excluded: 0 }"
                      v-slot="{ errors }">
                      <b-form-select :state="errors.length > 0 ? false : null" v-model="trademarkHistoryStatusSelect" value-field="id"
                        text-field="name" :options="trademarkHistoryStatusOption" size="sm" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form>
              </b-col>
            </b-row>
        </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>    
  export default {
    props: {
      getTrademarkHistoryList: {type: Function},
    },
    data() {
      return {
        id: 0,
        trademarkId:0,
        trademarkHistoryStatusSelect: 0,
        trademarkHistoryStatusOption: [],

        date: null,
        employeeId: '',
        locale: this.$i18n.locale,
      }
    },
    methods: {
      showInfo(id, trademarkId) {
        this.$refs['trademarkHistoryFormModal'].show()
        this.id = id
        this.trademarkId= trademarkId
        const data = { id: this.id }
        const controller = { name: 'TrademarkHistory' }
        const payload = { data: data, controller: controller}
        this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.trademarkHistoryStatusSelect = response.data.trademarkHistory.trademarkStatusId
            this.trademarkHistoryStatusOption = response.data.trademarkStatusList
            this.employeeId = response.data.trademarkHistory.employeeId
            this.date = response.data.trademarkHistory.date

            this.trademarkHistoryStatusOption.splice(0, 0, this.$nullSelected())
          } else {
            this.$bvModal.hide('trademarkHistoryFormModal')
            this.$WarningAlert(response.data.resultMessage)
          }
        })
        },
      addOrUpdate() {
        const data = {id: this.id, trademarkId: this.trademarkId, trademarkStatusId: this.trademarkHistoryStatusSelect, employeeId: localStorage.getItem('EmployeeId'), date: this.date}
        const controller = {name : 'TrademarkHistory'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
                this.$store.dispatch('moduleAuth/save',payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.$bvModal.hide('trademarkHistoryFormModal')
                    this.getTrademarkHistoryList()
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
          }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  .btn-group, .btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    height: 2.7em;
}
[dir] .btn-secondary {
  border: 1px solid #7367f0 !important;
  background-color: transparent !important;
}
.datepickerStyle{
  max-height: 2.2em;
  font-family: fangsong;
}
  </style>